import { EventItemCustomFieldAvailValueCreditType } from './event-item-custom-field-avail-value-credit-type.model';

export class EventCustomRegFieldAvailValues {
  public Id: number;
  public EventCustomRegFieldId: number;
  public Value: string;
  public Descr: string;
  public Amount: number;
  public UnitsAvailable: number;
  public UnitsTaken: number;
  public DisplayOrder: number = 0;

  public CreditTypes: Array<EventItemCustomFieldAvailValueCreditType> = [];
  public TaxAmount: number;

  public constructor() {
    this.Id = 0;
    this.EventCustomRegFieldId = 0;
    this.Value = '';
    this.Descr = '';
    this.Amount = 0;
    this.UnitsAvailable = 0;
    this.UnitsTaken = 0;
    this.TaxAmount = 0;
  }
}
